import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { RIDER_TYPES } from "@ipru-common/constants/SignatureUlipRider";

class QuoteFormStore {
  constructor() {
    /**
     * @type {SavingsQuoteForm}
     */
    this.quoteFormData = {};
    /**
     * @type {SavingsQuoteForm}
     */
    this.premiumRates = {};
    /**
     * @type {AllocatedFund[]}
     */
    this.defaultAllocatedFunds = [];
    /**
     * @type {AllocatedFund[]}
     */
    this.selectedFunds = [];
    this.negativePincodes = {};
  }

  setQuoteFormData(quoteFormData) {
    this.quoteFormData = quoteFormData;
  }

  /**
   * @returns {SavingsQuoteForm}
   */
  getQuoteFormData() {
    return this.quoteFormData;
  }

  setPremiumRates(premiumRates) {
    this.premiumRates = premiumRates;
  }
  /**
   * @returns {SavingsQuoteForm}
   */
  getPremiumRates() {
    return this.premiumRates;
  }

  setDefaultAllocatedFunds(defaultAllocatedFunds) {
    this.defaultAllocatedFunds = defaultAllocatedFunds;
  }

  /**
   * @returns {AllocatedFund[]}
   */
  getDefaultAllocatedFunds() {
    return this.defaultAllocatedFunds;
  }

  setField(fieldName, value) {
    this.quoteFormData[fieldName] = value;
  }

  setPaymentOption(paymentOption) {
    this.quoteFormData.paymentOption = paymentOption;
  }

  setPaymentFrequency(paymentFrequency) {
    this.quoteFormData.paymentFrequency = paymentFrequency;
  }

  setInvest(invest) {
    this.quoteFormData.invest = invest;
  }

  setLifeCover(lifeCover) {
    this.quoteFormData.lifeCover = lifeCover;
  }

  setPpt(ppt) {
    this.quoteFormData.ppt = ppt;
  }

  setTerm(term) {
    this.quoteFormData.term = term;
  }

  setAllocatedFunds(fundAllocation) {
    this.quoteFormData.allocatedFunds = fundAllocation;
  }

  setSelectedFunds(selectedFunds) {
    this.selectedFunds = selectedFunds;
  }

  getSelectedFunds() {
    return this.selectedFunds;
  }

  updateFields(fields) {
    this.quoteFormData = { ...this.quoteFormData, ...fields };
  }

  setNegativePincodes(negativePincodes) {
    this.negativePincodes = negativePincodes;
  }

  getNegativePincodes() {
    return this.negativePincodes;
  }

  checkOnlyWOPRiderSelected() {
    const wopRider = this?.quoteFormData?.selectedRiders?.find((current) => current?.sectionName === RIDER_TYPES.WOP);
    return wopRider;
  }

  setMasterData(masterData) {
    this.masterData = masterData;
  }

  getMasterData() {
    return this.masterData || {};
  }
  // setJointLife(value) {
  //   this.quoteFormData.isJointLife = value;
  // }
  // isJointLife() {
  //   return this.quoteFormData.isJointLife;
  // }
  isSingleLifeWithROP_CI_CD() {
    const allOptions = OPTION_VALUES?.ANNUITY_OPTIONS;
    const healthOptionAllowedRiders = [
      allOptions?.ME_NOMINEE[2],
      allOptions?.ME_JOINT[1],
      allOptions?.ME_JOINT_NOMINEE[1],
      allOptions?.ME_JOINT_NOMINEE[3],
    ];
    return healthOptionAllowedRiders.includes(this.quoteFormData?.selectedAnnuityOption?.annuityOption);
  }

  checkIsNpsCorpus() {
    return [OPTION_VALUES.Y_YES].includes(this.quoteFormData?.npsCorpus);
  }
}

export const QuoteFormStoreInstance = new QuoteFormStore();
